import type { TaskPalletRow } from '@/types'
import { Button } from '@/components/ui/button'

const STATUS_LABEL: Record<TaskPalletRow['status'], string> = {
  new: 'Свободна',
  in_progress: 'В работе',
  completed: 'Завершена',
}

interface PalletPickerProps {
  pallets: TaskPalletRow[]
  workerName: string
  onTake: (pallet: TaskPalletRow) => void
  onContinue: (pallet: TaskPalletRow) => void
}

export function PalletPicker({ pallets, workerName, onTake, onContinue }: PalletPickerProps) {
  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Выберите паллету</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {pallets.map(pallet => {
          const isMine =
            pallet.status === 'in_progress' && pallet.worker_name === workerName
          const isBusy =
            pallet.status === 'in_progress' && pallet.worker_name !== workerName
          const isDone = pallet.status === 'completed'
          const occupant = pallet.status === 'in_progress' ? pallet.worker_name : undefined

          return (
            <div
              key={pallet.num}
              className="bg-white rounded-xl border border-gray-200 p-5 flex flex-col gap-3"
            >
              <div className="flex items-start justify-between gap-2">
                <h3 className="text-base font-semibold text-gray-900">Паллета №{pallet.num}</h3>
                <span
                  className={`text-xs px-2 py-1 rounded-full shrink-0 ${
                    isDone
                      ? 'bg-green-100 text-green-800'
                      : isBusy
                        ? 'bg-amber-100 text-amber-800'
                        : isMine
                          ? 'bg-blue-100 text-blue-800'
                          : 'bg-gray-100 text-gray-600'
                  }`}
                >
                  {isBusy && occupant
                    ? `Занята · ${occupant}`
                    : isMine && occupant
                      ? `Вы · ${occupant}`
                      : STATUS_LABEL[pallet.status]}
                </span>
              </div>
              <p className="text-sm text-gray-500">Коробок: {pallet.boxes_count}</p>
              {isMine ? (
                <Button className="w-full" onClick={() => onContinue(pallet)}>
                  Продолжить
                </Button>
              ) : isDone ? (
                <Button className="w-full" variant="secondary" disabled>
                  Завершена
                </Button>
              ) : isBusy ? (
                <Button className="w-full" variant="secondary" disabled>
                  Занята{occupant ? ` (${occupant})` : ''}
                </Button>
              ) : (
                <Button className="w-full" onClick={() => onTake(pallet)}>
                  Взять в работу
                </Button>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
